import { Text } from "@meditect/medibase-components";

export const SalesCannotRefundBilledSaleError = () => {
  return <Text>Cette vente est rattachée à une facture. Réglez ou annulez la facture avant de la rembourser.</Text>;
};
